/* esm.sh - rxjs@7.8.2/dist/esm/internal/scheduler/intervalProvider */
export * from "/*rxjs@7.8.2/esnext/dist/esm/internal/scheduler/intervalProvider.mjs";
